module.exports = __webpack_public_path__ + "static/media/bunbury-rsl.e6dbc04a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/TheMoshiDifference/bunbury-rsl.jpg
// module id = 183
// module chunks = 0